<app-modal
  [visible]="tour.active()"
  (visibleChange)="onVisibleChange($event)"
  [showHeader]="false"
  [showFooter]="false"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [modal]="false"
  [blockScroll]="false"
  [width]="tour.mode() === 'welcome' ? '35rem' : '23.75rem'"
  [styleClass]="tour.mode() === 'welcome' ? 'custom-modal tour-dialog tour-dialog--welcome' : 'custom-modal tour-dialog tour-dialog--step'"
>
  <!-- Welcome -->
  <div class="tour-welcome" *ngIf="tour.mode() === 'welcome'">
    <button
      type="button"
      class="tour-welcome__close"
      aria-label="Close panel demo"
      (click)="tour.close()"
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>

    <div class="tour-welcome__illustration" aria-hidden="true">
      <img
        src="/tour/welcome-dashboard.png"
        alt=""
        class="tour-welcome__illustration-img"
      />
    </div>

    <h2 class="tour-welcome__title">
      Welcome to the {{ tour.panelLabel() }} Panel
    </h2>
    <p class="tour-welcome__body" *ngIf="!isDelegatePanel">
      Your personalized workspace for discovering datasets, monitoring requests,
      managing projects, and accessing everything you need to collaborate and innovate.
    </p>
    <p class="tour-welcome__body" *ngIf="isDelegatePanel">
      Your personalized workspace for discovering datasets, monitoring requests,
      and accessing everything you need while acting on an owner's behalf.
    </p>
    <h3 class="tour-welcome__subtitle">Need a quick overview?</h3>
    <p class="tour-welcome__hint">
      Click 'Next' for a quick tour of the {{ tour.panelLabel() }} Panel and
      discover how to make the most of its features.
    </p>

    <div class="tour-welcome__actions">
      <button type="button" class="tour-btn tour-btn--primary" (click)="tour.next()">
        Next
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="5" y1="12" x2="19" y2="12"></line>
          <polyline points="12 5 19 12 12 19"></polyline>
        </svg>
      </button>
    </div>
  </div>

  <!-- Step -->
  <div class="tour-step" *ngIf="tour.mode() === 'step' && tour.currentStep() as step">
    <div class="tour-step__header">
      <div class="tour-step__badge" aria-hidden="true">
        <img
          src="/tour/start-sparkle.png"
          alt=""
          class="tour-step__badge-icon"
          width="16"
          height="16"
        />
      </div>
      <span class="tour-step__counter">
        Step {{ tour.stepIndex() + 1 }} of {{ tour.totalSteps() }}
      </span>
      <button
        type="button"
        class="tour-step__close"
        aria-label="Close panel demo"
        (click)="tour.close()"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <h2 class="tour-step__title">{{ step.title }}</h2>
    <p class="tour-step__body">{{ step.description }}</p>

    <div
      class="tour-step__progress"
      role="progressbar"
      [attr.aria-valuenow]="tour.stepIndex() + 1"
      [attr.aria-valuemin]="1"
      [attr.aria-valuemax]="tour.totalSteps()"
    >
      <span
        *ngFor="let _ of tour.steps(); let i = index"
        class="tour-step__dot"
        [class.tour-step__dot--active]="i === tour.stepIndex()"
        [class.tour-step__dot--done]="i < tour.stepIndex()"
      ></span>
    </div>

    <div class="tour-step__footer">
      <button
        type="button"
        class="tour-btn tour-btn--ghost"
        [disabled]="tour.isFirstStep()"
        (click)="tour.back()"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="19" y1="12" x2="5" y2="12"></line>
          <polyline points="12 19 5 12 12 5"></polyline>
        </svg>
        Back
      </button>

      <button
        type="button"
        class="tour-btn tour-btn--primary"
        (click)="tour.isLastStep() ? tour.finish() : tour.next()"
      >
        {{ tour.isLastStep() ? 'Finish' : 'Next' }}
        <svg *ngIf="!tour.isLastStep()" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="5" y1="12" x2="19" y2="12"></line>
          <polyline points="12 5 19 12 12 19"></polyline>
        </svg>
      </button>
    </div>
  </div>
</app-modal>
